<div class="d-flex">
    <img [src]="imageEndpoint" />
</div>
